export const DEFAULT_MODE = 'default';
export const FUNDRAISING_MODE = 'fundraising';
